<template lang="pug">
div(ref="header")
  h1 Jouw verjaardag in
    select.constant-select(v-model="constant", @change="lookingFor = ''")
      option(v-for="c in constants", :value="c.id") {{ c.text }}

  input(v-model="lookingFor", type="text")

SearchInPi(
  :lookingFor="digitsQuery",
  :constant="constant",
  :maxWidth="maxWidth",
  :maxHeight="maxHeight"
)
</template>

<script>
import SearchInPi from "./components/SearchInPi.vue";

export default {
  components: {
    SearchInPi,
  },
  mounted() {
    this.resizeCallback = () => this.resize();
    window.addEventListener("resize", this.resizeCallback);
    this.resize();
  },
  unmounted() {
    window.removeEventListener("resize", this.resizeCallback);
  },
  data() {
    return {
      maxWidth: 300,
      maxHeight: 500,
      lookingFor: "314159",
      constant: "pi",
      constants: [
        {
          text: "π",
          id: "pi",
        },
        {
          text: "e",
          id: "e",
        },
        {
          text: "√2",
          id: "sqrt2",
        },
        {
          text: "φ",
          id: "phi",
        },
      ],
    };
  },
  computed: {
    digitsQuery() {
      return ("" + this.lookingFor).replace(/[^0-9]/g, "");
    },
  },
  methods: {
    resize() {
      this.maxWidth = 0.9 * window.innerWidth;
      this.maxHeight =
        0.9 * window.innerHeight - this.$refs.header.clientHeight;
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  padding: 0;
}

select.constant-select {
  border: black 0 solid;
  border-bottom-width: 2px;
  padding-bottom: 2px;
  font-size: inherit;
  font-family: inherit;
  background: transparent;
  text-align: right;
  cursor: pointer;

  &:hover,
  &:focus,
  &:focus-visible {
    border: black 0 solid;
    border-bottom-width: 4px;
    padding-bottom: 0px;
    outline: none;
  }
}
</style>
